Object.defineProperty(exports,"__esModule",{value:true});exports.useTelegramAnalytics=void 0;var _react=require("react");
var _utils=require("@24i/nxg-sdk-higgs/src/utils");
var _utils2=require("./utils");

var useTelegramAnalytics=function useTelegramAnalytics(){
(0,_react.useEffect)(function(){
if(!(0,_utils.isWebView)())return undefined;

var script=document.createElement('script');
script.type='text/javascript';
script.src='https://tganalytics.xyz/index.js';
script.async=true;
script.onload=function(){
(0,_utils2.initAnalytics)();
};
document.head.appendChild(script);

return function(){
document.head.removeChild(script);
};
},[]);
};exports.useTelegramAnalytics=useTelegramAnalytics;